import { render, staticRenderFns } from "./ErrorInput.vue?vue&type=template&id=881ecd2c&"
import script from "./ErrorInput.vue?vue&type=script&lang=js&"
export * from "./ErrorInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports